import { mainFetch } from "../mainFetch"

const SERVICE_URL = '/provider/komus'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class KomusApi {

    static async updateProducts({ data = undefined, ...params }) {
        return await fetchService({ url: '/updateproducts', method: 'POST', data, ...params })
    }

    static async updateStocks({ data = undefined, ...params }) {
        return await fetchService({ url: '/updatestocks', method: 'POST', data, ...params })
    }

}